import axios from 'axios';
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paginate from '../components/Paginate';
import { Table, Button,Row,Col } from 'react-bootstrap';
import{PRODUCT_CREATE_RESET} from '../constants/productConst'
import{REGISTER_EVENT_LIST_SUCCESS} from '../constants/resgistertEventConst'
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { updateuserevent} from '../actions/usereventActions';
import { listProducts,deleteProduct,createProduct, updateProduct} from '../actions/productActions';
import { useHistory } from 'react-router-dom';
import { useEventContext } from './EventContext';
import { Card, CardImg } from 'react-bootstrap';
import HomeScreen from './HomeScreen';



 const UsereventScreen = ({location,history}) => {
 const productList = useSelector((state) => state.productList);
 // const { loading, error, products,pages,page } = productList;
 const productDelete = useSelector((state) => state.productDelete);
 const { loading:loadingDel, error:errorDel, success:successDel } = productDelete;
 const productCreate = useSelector((state) => state.productCreate);
 const { loading:loadingCreate, error:errorCreate, success:successCreate,product:createdProduct } = productCreate;
 const userLogin = useSelector((state) => state.userLogin);
 const { userInfo } = userLogin;
 const [registerevent, setRegisterevent] = useState([]);
 const [userevents, setUserevent] = useState([]);
 const dispatch = useDispatch();
 const createdDate = new Date().toISOString();
 const [products, setProducts] = useState([]);
 const eventId = location.pathname.split('/')[2];
 const [checked, setChecked] = useState(false);
 const { setEventId } = useEventContext();
 
 const [checkedItems, setCheckedItems] = useState([]);
 const [responseMessage, setResponseMessage] = useState('');
 const [userinfo, setUserInfo] = useState({ 
    languages: [], 
    chkrespo: [], 
  });

 /*
 const handleCheckboxChange = (event) => {
  const { name, checked } = event.target;

  if (checked) {
    // If the checkbox is checked, add its value to the array
    setCheckedItems((prevCheckedItems) => [...prevCheckedItems, name]);
  } else {
    // If the checkbox is unchecked, remove its value from the array
    setCheckedItems((prevCheckedItems) =>
      prevCheckedItems.filter((item) => item !== name)
    );
  }
};
 */

const handleChange = (e) => { 
  // Destructuring 
  const { value, checked } = e.target; 
  const { languages } = userinfo; 
    
  console.log(`${value} is ${checked}`); 
  
  // Case 1 : The user checks the box 
  if (checked) { 
    setUserInfo({ 
      languages: [...languages, value], 
      chkrespo: [...languages, value], 
    }); 
  } 

  // Case 2  : The user unchecks the box 
  // else { 
  //   setUserInfo({ 
  //     languages: languages.filter((e) => e !== value), 
  //     chkrespo: languages.filter((e) => e !== value), 
  //   }); 
  // } 
  
}; 


 useEffect(() => {    
      // dispatch(listProducts())    
      //Shopline.handle -> 4wsxmz
      axios.get(`https://wiser-ai.expertvillagemedia.com/api/getproduct/${window.Shopline.handle}/${eventId}/${window.Shopline.customer.id}`)
      .then((res) => {
          //const {userevents, page, pages} = res.data
          setUserevent(res.data.data)
          setRegisterevent(res.data.data);
          console.log(res.data.data);      
          // debugger
          const createdDate = new Date().toISOString();
      });      
  }, []);


const deleteHandler=(id)=>{
  if(window.confirm('Are you sure?')){
    dispatch(deleteProduct(id))
  }
}

const createProductHandler=()=>{
    dispatch(createProduct())
}

const updateProductHandler = useCallback( (id) => {
  
  return async (e) => {
    e.preventDefault()
    
    /** UPDATE API CALL */
    const config = {
      headers: {
        //Authorization:`Bearer ${userInfo.token}`
      },
    }
    
    const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/updateproductqty`;
    const commonResponse = fetch(AppEndPointURL, {
        method: "POST",
        headers:
        {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Allow": "OPTIONS, GET, HEAD, POST",
        },
        body: JSON.stringify({
          registry_id: `${eventId}`,
          customer_id: `${window.Shopline.customer.id}`,
          quantity: e.target.value
        }),
    })
    .then((response) => response.json());
    axios.get(`https://wiser-ai.expertvillagemedia.com/api/getproduct/${window.Shopline.handle}/${eventId}/${window.Shopline.customer.id}`)
    .then((res) => {
        setUserevent(res.data.data)
        setRegisterevent(res.data.data);          
    });
    //{userevents.map((product, index) => (
    //dispatch(updateuserevent(id, e.target.value)) 
    //))}
  }

}, [])

/*const updateProductHandler=(a, pid, c)=> {
  console.log("e.target.value");
  console.log(1);
  console.log("pid = ");
  console.log(pid);
  console.log(c);  
  {userevents.map((product, index) => (
    dispatch(updateuserevent(product, e.target.value)) 
  ))}
  }
*/

const handleAddProductsClick = () => {    
  setEventId(eventId);
  localStorage.setItem('gift_registry_id', eventId);
};
  
const evm_giftreg_addcart = (e) => {
    e.preventDefault();
    
    let itemArray = [];    
    userinfo.chkrespo.map((item) => {
        let idata = item.split('_');
        // let pid = idata[0];
        // let qty = idata[1];                  

        const ArtParas12 = {
            "items": [
                {
                  "id": "18061491974695674387872080",
                  "quantity": idata[1]
                }
            ]
        }
        axios.post('/cart/add.js', ArtParas12)
        .then(response =>  console.log(response.data))
        .catch(error => {
            console.log("555555555555555555555555555555555555555555");
            console.error('There was an error!', error);
            console.log("555555555555555555555555555555555555555555");
        });
        return itemArray;
    });

    const ArtPar = {
        "items": [
            {
              "id": "18061491974695674387872080",
              "quantity": 1
            }
        ]
    }
    axios.post('/cart/add.js', ArtPar)
    .then(response =>  console.log(response.data))
    .catch(error => {
        console.log("555555555555555555555555555555555555555555");
        console.error('There was an error!', error);
        console.log("555555555555555555555555555555555555555555");
    });
    //const myObjStr = JSON.stringify(items);
    // axios.post('/cart/add.js', ArtParas)
    // .then(response =>  console.log(response.data))
    // .catch(error => {
    //     console.log("555555555555555555555555555555555555555555");
    //     console.error('There was an error!', error);
    //     console.log("555555555555555555555555555555555555555555");
    // });
    return itemArray;
};

return (     
      <div className="aaagift-manage-regi">
      <Link to="/pages/evmnew"> CLOSE </Link>  
      <div className="full-width" style={{ textAlign: 'center' }}>
        <h3 className="block-title">{registerevent.regtitle}</h3>
        <p>{registerevent.regmessage}</p>
      </div>
      <div> 
        <table className="table table-bordered searchlist_responsive table_custom">
          <thead className="sm_d_none">
            <tr>
              <th style={{ width: 'auto' }}>NAME OF THE EVENT</th>
              <th style={{ width: 'auto' }}>RECORD OWNER</th>
              <th style={{ width: 'auto' }}>CREATION DATE</th>
              <th style={{ width: 'auto' }} className="">EVENT DATE</th>
              <th style={{ width: 'auto' }} className="">ADDITIONAL INFORMATION</th>
            </tr>
          </thead>
          <tbody>              
            <td>{registerevent.regtype}</td>
            <td>{registerevent.r_fname}</td>
            <td>{createdDate}</td>
            <td>{registerevent.regdate}</td>
            <td>{registerevent.regaddinfo}</td>
          </tbody>
        </table>     
        <form id="aaa-registry-products-form">
          <div className="table-responsive sm_border_none">
            <table className="table table-bordered table_custom registry_products_table_responsive">
            <thead>
              <tr>                
                <th>YES NO</th>
                <th>SELECTED ITEMS</th>
                <th>PRODUCT NAME</th>
                <th>PRODUCT PRICE</th>
                <th>PRODUCT IMAGE</th>
                <th>QUANTITY</th>                
                <th>UPDATE QUANTITY</th>           
              </tr>
            </thead>
              <tbody>
              {userevents.map((product, index) => (
                  <tr key={index}>
                  {/* Populate the table cells with the registry data */}
                  <td>
                  <input 
                    className="form-check-input"
                    type="checkbox"
                    name={product.name}
                    value={`${product.product_id}_${product.quantity}`}
                    id={`evm_chkbox_${product.id}`}
                    onChange={handleChange} 
                  />                   
                  </td>
                  <td>{index + 1}</td>
                  <td>{product.name}</td>
                  <td>{product.price}</td>                  
                  <td><Image alt={product.name} src={product.image} style={{width:'150px'}} /></td>
                  <td>{product.quantity}</td>
                  <td><input type='number' id={`evm_qty_${product.product_id}`} style={{width: "80px",height: "40px"}} defaultValue={product.quantity} onChange={updateProductHandler(product._id)}  min={0} max={product.available_quantity}/></td>               
                </tr>
              ))}           
            </tbody>
            </table>
          </div>          
          <div className="full-width update_cart_bottom_fix" style={{ borderRadius: '0 !important', textAlign: 'center' }}>
            <div className="btn_wrapper">    
              <button className="btn btn-primary demolink" onClick={handleAddProductsClick}>
                Add products in the registry
              </button>
              <button className="btn btn-danger addtocart evm_giftreg_addcart wgr" onClick={evm_giftreg_addcart} >
                  Add To Cart
              </button>       
            </div>
          </div>
        </form>
        <div className="full-width">
        </div>
      </div>
    </div>
    );
  };
  
  export default UsereventScreen;